<template>
    <div class="workOrder">
        <div class="tableCont">
            <div class="tabCont">
                <el-tabs
                    v-model="searchForm.status"
                    type="border-card"
                    @tab-click="workOrdersList"
                    ref="tabs"
                >
                    <el-tab-pane
                        v-for="item in statusList"
                        :key="item.status"
                        :name="item.status"
                    >
                        <span slot="label" class="label"
                            ><!-- <i class="el-icon-box"></i> -->{{
                                item.name
                            }}
                            {{ item.total }}</span
                        >
                    </el-tab-pane>
                </el-tabs>
            </div>
            <el-drawer
                title="高级搜索"
                :visible.sync="drawerVisible"
                size="320px"
                class="drawerCont"
                ref="drawer"
                :wrapperClosable="false"
            >
                <el-scrollbar class="scrollbar">
                    <el-form
                        :model="searchForm"
                        label-width="120"
                        class="drawerForm"
                        label-position="left"
                    >
                        <el-form-item
                            label="已确认"
                            size="mini"
                            label-width="50px"
                            style="height: 40px"
                        >
                            <el-checkbox-group
                                v-model="searchForm.confirmedList"
                                @change="confirmChange"
                            >
                                <el-checkbox  label="是" border></el-checkbox>
                                <el-checkbox label="否" border></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                      <el-form-item
                          label="类型"
                          size="mini"
                          label-width="50px"
                          style="height: 40px"
                      >
                        <el-checkbox-group
                            v-model="searchForm.typeList"
                            @change="typeChange"
                        >
                          <el-checkbox label="需求" border></el-checkbox>
                          <el-checkbox  label="BUG" border></el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                      <el-form-item
                            label="优先级"
                            size="mini"
                            label-width="50px"
                            style="height: 40px"
                        >
                            <el-radio-group
                                v-model="searchForm.priority"
                                size="mini"
                            >
                            <el-radio :label="1">低</el-radio>
                            <el-radio :label="2">中</el-radio>
                            <el-radio :label="3">高</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="版本号" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入关键字"
                                size="mini"
                                v-model="searchForm.version"
                                @keydown.enter.native="workOrdersList"
                                @clear="workOrdersList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="关键字" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入关键字"
                                size="mini"
                                v-model="searchForm.keyword"
                                @keydown.enter.native="workOrdersList"
                                @clear="workOrdersList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="创建人" size="mini">
                            <el-select
                                v-model="searchForm.user_id"
                                filterable
                                placeholder="请选择创建人"
                                clearable
                                @change="workOrdersList"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="需求人" size="mini">
                            <el-select
                                v-model="searchForm.demand_user_id"
                                filterable
                                placeholder="请选择响应人"
                                clearable
                                @change="workOrdersList"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="评审人" size="mini">
                            <el-select
                                v-model="searchForm.handle_user_id"
                                filterable
                                placeholder="请选择评审人"
                                clearable
                                @change="workOrdersList"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源" size="mini">
                            <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择来源"
                                multiple
                                collapse-tags
                                clearable
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    @change="workOrdersList"
                                    @clear="workOrderClear"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.create_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="评审时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.response_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="预计解决时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.estimate_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="解决时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.processed_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="验收时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.check_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="text-align: right">
                            <el-button
                                type="danger"
                                icon="el-icon-refresh-right"
                                size="small"
                                @click="clean"
                                >重置条件</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div class="drawer-footer">
                    <el-button
                        style="width: 100%"
                        type="primary"
                        icon="el-icon-search"
                        size="small"
                        @click="workOrdersList"
                    >
                        查询
                    </el-button>
                </div>
            </el-drawer>
            <div class="searchCont">
                <div class="searchContLeft">
                    <el-form
                        :inline="true"
                        :model="searchForm"
                        label-width="120"
                    >
                        <el-form-item label="关键字" size="mini">
                            <el-input
                                clearable
                                placeholder="请输入关键字"
                                size="mini"
                                v-model="searchForm.keyword"
                                @keydown.enter.native="workOrdersList"
                                @clear="workOrdersList"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="来源" size="mini">
                            <el-select
                                v-model="searchForm.project_id"
                                filterable
                                placeholder="请选择来源"
                                multiple
                                collapse-tags
                                clearable
                                @change="workOrdersList"
                                @clear="workOrderClear"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.create_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="响应时间" size="mini">
                            <el-date-picker
                                v-model="searchForm.response_time"
                                prefix-icon="el-icon-date theme-color"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="一"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                @change="workOrdersList"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item> -->
                    </el-form>
                    <el-button
                        icon="el-icon-search"
                        size="mini"
                        type="primary"
                        style="margin-right: 10px"
                        @click="workOrdersList(1)"
                    ></el-button>
                    <div v-if="this.menuAuth">
                        <el-button v-for="item in menuAuth"
                            :key="item.id"
                            type="primary"
                            :icon="item.icon"
                            size="mini"
                            @click="authFunc(item.funcName)"
                        >
                            {{ item.name }}
                        </el-button>
                    </div>
                </div>
                <div class="searchContRight">
                    <el-popover
                        placement="bottom-start"
                        width="390"
                        trigger="click"
                    >
                        <el-form
                            :label-width="auto"
                            style="
                                display: flex;
                                margin-bottom: 10px;
                            "
                            inline
                        >
                            <el-row>
                                <el-col span="1">&nbsp;</el-col>
                                <el-col span="16">
                                    <el-form-item label="周期" size="mini">
                                        <el-select
                                            v-model="week"
                                            filterable
                                            placeholder="请选择周期"
                                            clearable
                                            @change="getWorkOrdersCompletion"
                                            style="width: 150px;"
                                        >
                                            <el-option
                                                v-for="item in weeks"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="7">
                                    <el-button
                                            type="primary"
                                            icon="el-icon-refresh-right"
                                            size="mini"
                                            @click="buildStat(0)"
                                        >
                                            生成报告
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                        <!-- <div class="table"> -->
                        <el-table
                            :data="completionData"
                            max-height="450"
                            :header-cell-style="{
                                fontSize: '12px',
                                fontWeight: 500,
                                textAlign: 'center',
                            }"
                            :cell-style="{
                                fontSize: '12px',
                                fontWeight: 500,
                                textAlign: 'center',
                            }"
                        >
                            <el-table-column
                                property="week"
                                label="周期"
                            ></el-table-column>
                            <el-table-column
                                property="total_task"
                                width="60"
                                label="新增"
                            ></el-table-column>
                            <el-table-column
                                property="wait_task"
                                label="待处理"
                                width="60"
                            ></el-table-column>
                            <el-table-column
                                property="finish_task"
                                label="已完成"
                                width="60"
                            ></el-table-column>
                            <el-table-column
                                property="rate"
                                label="完成率"
                                width="60"
                            ></el-table-column>
                            <el-table-column
                                property=""
                                label="报告"
                                width="60"
                            >
  
                            <template slot-scope="scope">
                                <!-- <div @click="buildStat(scope.row.id)">生成</div> -->
                                <i class="el-icon-tickets report-icon" title="记录" @click="showReport(scope.row.content)"></i>
                                <i class="el-icon-refresh-right report-icon" title="生成" @click="buildStat(scope.row.id)"></i>
                            </template>

                            </el-table-column>
                        </el-table>
                        <!-- </div> -->
                        <el-button
                            class="document btn5"
                            type="text"
                            slot="reference"
                            icon="el-icon-document-copy"
                            plain
                            size="mini"
                        >
                            <span>统计</span>
                            <div class="line_tl"></div>
                            <div class="line_tr"></div>
                            <div class="line_bl"></div>
                            <div class="line_br"></div>
                            <div class="line_all"></div>
                        </el-button>
                    </el-popover>
                    <!-- 高级搜索 -->
                    <advancedSearch
                        :drawerVisible.sync="drawerVisible"
                        style="height: 100%; margin-left: 10px"
                        >高级搜索</advancedSearch
                    >
                </div>
            </div>
            <!-- <search_infoTags
                :searchForm="searchForm"
                :searchList="searchList"
                :funcName="'workOrdersList'"
            ></search_infoTags> -->
            <div class="table" :style="{ height: height }">
                <el-table ref="ordersList" :data="tableData" highlight-current-row height="100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
                    <el-table-column
                        type="selection"
                        align="center"
                        :fixed="checkFixed"
                    >
                    </el-table-column>
                    <el-table-column
                        label="工单号"
                        property="order_sn"
                        align="left"
                        fixed
                        show-overflow-tooltip
                    >
                      <template slot-scope="scope">
<!--                        <i class="el-icon-share"  v-if="scope.row.type == 2"></i>-->
                        <el-image class="list-icon" :src="require(`@/assets/image/p${scope.row.priority}.svg`)"></el-image>
                        <el-image class="list-icon" v-if="scope.row.type == 2" :src="require('@/assets/image/bug-fill.svg')"></el-image>
                        {{scope.row.order_sn}}
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="标题"
                        property="name"
                        align="left"
                        fixed
                        show-overflow-tooltip
                        min-width="300"
                    >
                    </el-table-column>
                    <el-table-column
                        label="来源"
                        align="left"
                        property="project_name"
                        fixed
                    >
                    </el-table-column>
                    <el-table-column label="状态" align="left" width="85" fixed>
                        <template slot-scope="scope">
                            <el-tag
                                size="mini"
                                :type="
                                    scope.row.status == 1 ||
                                    scope.row.status == 5
                                        ? 'info'
                                        : scope.row.status == 10
                                        ? 'warning'
                                        : scope.row.status == 20 ||
                                          scope.row.status == 30 ||
                                          scope.row.status == 40
                                        ? 'success'
                                        : scope.row.status == 50 ||
                                          scope.row.status == 99
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ scope.row.status_cn }}
                            </el-tag>
                            <i
                                class="el-icon-success confirmed"
                                v-if="scope.row.confirmed == 1"
                            ></i>
                            <i class="el-icon-error noconfirm" v-else></i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        property="user_name"
                        align="left"
                        width="150"
                        fixed
                    >
                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <span class="el-avatar el-avatar--small el-avatar--circle"><img :src="scope.row.avatar || scope.row.user_name && `https://uc-api.loratech.cn/dingtalk/2/user/${encodeURIComponent(scope.row.user_name)}/avatar/50` || defaultAvatar" style="object-fit: cover;" :onerror="`src='${defaultAvatar}'`"></span>
                          </div>
                          <div class="memberName">
                            {{ scope.row.user_name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="需求人"
                        property="demand_user_avatar"
                        align="left"
                        width="150"
                        fixed
                    >
                      <template slot-scope="scope">
                        <div class="nameCont">
                          <div class="headImg" >
                            <span class="el-avatar el-avatar--small el-avatar--circle"><img :src="scope.row.demand_user_avatar || scope.row.demand_user_name && `https://uc-api.loratech.cn/dingtalk/2/user/${encodeURIComponent(scope.row.demand_user_name)}/avatar/50` || defaultAvatar" style="object-fit: cover;" :onerror="`src='${defaultAvatar}'`"></span>
                          </div>
                          <div class="memberName">
                            {{ scope.row.demand_user_name }}
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="BUG"
                        width="120"
                        align="center"
                        fixed
                        v-if="[10, 20].includes(parseInt(searchForm.status))"
                    >
                      <template slot-scope="scope">
                        <div>
                            <img src="../../../assets/image/bug-fill.svg" style="width: 12px; height: 12px; display: inline-block; margin-right: 10px;" />
                            <span style="cursor: pointer; color: #eb5202; display: inline-block" @click="showTrack(scope.row, [0,2])">{{ scope.row.track && scope.row.track.unfixed || 0 }}</span> / <span style="cursor: pointer; color: #3a7ffa" @click="showTrack(scope.row, [1])">{{ scope.row.track && scope.row.track.fixed || 0 }}</span>  / <span style="cursor: pointer; color: #67c23a" @click="showTrack(scope.row, [3])">{{ scope.row.track && scope.row.track.accepted || 0 }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        property="create_time"
                        align="left"
                        width="150"
                        :default-sort="{ prop: 'orderby_create_time', order: 'descending' }"
                        sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                        label="评审时间"
                        property="response_time"
                        align="left"
                        width="150"
                        :default-sort="{ prop: 'orderby_response_time', order: 'descending' }"
                        sortable="custom"
                    >
                    </el-table-column>
                  <el-table-column
                      label="预计解决时间"
                      property="estimate_time"
                      align="left"
                      width="150"
                      :default-sort="{ prop: 'orderby_estimate_time', order: 'descending' }"
                      sortable="custom"
                  >
                    <template slot-scope="scope">
                        <span style="padding-right:5px">{{scope.row.estimate_time}}</span><i class="el-icon-edit" v-if="scope.row.estimate_time && role==1" @click="modifyEstime(scope.row)"></i>
                    </template>
                  </el-table-column>
                    <el-table-column
                        label="解决时间"
                        property="processed_time"
                        align="left"
                        width="150"
                        :default-sort="{ prop: 'orderby_processed_time', order: 'descending' }"
                        sortable="custom"
                    >
                    </el-table-column>
                    <el-table-column
                        label="验收时间"
                        property="check_time"
                        align="left"
                        width="150"
                        :default-sort="{ prop: 'orderby_check_time', order: 'descending' }"
                        sortable="custom"
                    >
                    </el-table-column>
<!--                    <el-table-column
                        label="任务ID"
                        property="job_id"
                        align="center"
                        width="80"
                    >
                        <template slot-scope="scoped">
                            <p
                                :class="[
                                    scoped.row.job_id > 0
                                        ? 'link'
                                        : 'cursor_not_allowed',
                                ]"
                                @click="jump(scoped.row)"
                            >
                                {{ scoped.row.job_id }}
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="任务状态" align="center" width="80">
                        <template slot-scope="scope">
                            <el-tag
                                v-if="scope.row.job_status_cn"
                                size="mini"
                                :type="
                                    scope.row.job_status == 1
                                        ? 'info'
                                        : scope.row.job_status == 5
                                        ? 'warning'
                                        : scope.row.job_status == 10 ||
                                          scope.row.job_status == 20
                                        ? 'success'
                                        : scope.row.job_status == 99
                                        ? 'danger'
                                        : ''
                                "
                            >
                                {{ scope.row.job_status_cn }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="总耗时" align="left" width="80">
                        <template
                            slot-scope="scope"
                            v-if="scope.row.total_time != 0"
                        >
                            {{ scope.row.total_time }}天
                        </template>
                    </el-table-column>
                    <el-table-column label="排序" align="center" :default-sort="{ prop: 'orderby_sort', order: 'descending' }" property="sort" width="80" sortable="custom">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.sort" class="sort-input" size="mini" @blur="changeSort(scope.row.id,$event)"></el-input>
                        </template>
                    </el-table-column>-->
                  <el-table-column prop="authority" label="操作" align="left" width="150" fixed="right">
                    <template slot-scope="scope">
                      <div>
              <span v-if="scope.row.authority && scope.row.authority.length <= 3">
                 <div class="operation-btns">
                                <span style="-webkit-text-fill-color:#eb5202;"
                                    v-for="item in scope.row.authority"
                                    :key="item.id"
                                >
                                    <el-button
                                        v-if="item.status_flag != 4"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        :class="
                                            item.name == '删除' ? 'redText' : ''
                                        "
                                        @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                    >
                                    <popConfirm
                                        v-else
                                        :title="item.name"
                                        :buttonText="item.name"
                                        @confirm="updateStatus(scope.row, item)"
                                    >
                                    </popConfirm>
                                </span>
                            </div>
              </span>
                        <!-- 超过三个操作按钮展示 -->
                        <span v-else>
                              <span style="margin-right: 2px;-webkit-text-fill-color:#eb5202;"
                                  v-for="item in scope.row.authority"
                                  :key="item.id"
                              >
                                    <el-button
                                        v-if="item.status_flag != 4 && item.name=='查看'"
                                        type="text"
                                        size="small"
                                        class="color-blue"
                                        @click="rowDo(scope.row, item)"
                                    >{{ item.name }}</el-button
                                    >
                                </span>

                            <el-dropdown size="small">
                                <span class="el-dropdown-link" style="-webkit-text-fill-color:#eb5202;">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <template v-for="(item, index) in scope.row.authority">
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="index" v-if="item.status_flag != 4 && item.name!='查看'"  @click="rowDo(scope.row, item)" @confirm="updateStatus(scope.row, item)">
                                            <el-dropdown-item >{{ item.name }}</el-dropdown-item>
                                        </span>
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="`${index}-4`" v-else-if="item.status_flag == 4 && item.name!='响应' && item.name!='确认'"  @click="confirmUpdateStatus(scope.row, item)">
                                            <el-dropdown-item >{{ item.name }}</el-dropdown-item>
                                        </span>
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="`${index}-4-1`" v-else-if="item.status_flag == 4 && item.name=='响应'"  @click="confirmResponse(scope.row, item)">
                                            <el-dropdown-item >{{ item.name }}</el-dropdown-item>
                                        </span>
                                        <span style="-webkit-text-fill-color:#eb5202;" :key="`${index}-4-2`" v-else-if="item.status_flag == 4 && item.name=='确认'"  @click="confirmed(scope.row, item)">
                                            <el-dropdown-item >{{ item.name }}</el-dropdown-item>
                                        </span>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>

            <pagination
                :paginationData="paginationData"
                @paginationChange="paginationChange"
            ></pagination>
            <workOrderAdd
                :addVisible.sync="addVisible"
                :projectList="projectList"
            ></workOrderAdd>
            <workOrderRefuse
                :refuseVisible.sync="refuseVisible"
                :tableItem="tableItem"
            ></workOrderRefuse>
            <workOrderEdit
                :editVisible.sync="editVisible"
                :tableItem="tableItem"
                :projectList="projectList"
            ></workOrderEdit>
            <workOrderDetail
                :detailVisible.sync="detailVisible"
                :tableItem="tableItem"
                :tableData="tableData"
            ></workOrderDetail>
          <showLogDetail
              :showLogVisible.sync="showLogVisible"
              :tableItem="tableItem"
          ></showLogDetail>
            <jobAdd
                :addVisible.sync="jobAddVisible"
                :tableItem="tableItem"
            ></jobAdd>
            <jobDetail
                :detailVisible.sync="jobDetailVisible"
                :tableItem="tableItem"
            ></jobDetail>
          <workOrderEstimatetime
              :estimatetimeVisible.sync="estimatetimeVisible"
              :tableItem="tableItem"
          ></workOrderEstimatetime>
          <workOrderReport
                :reportVisible.sync="reportVisible"
                :reportConrent="reportConrent"
            ></workOrderReport>
            <workOrderConfirm
                :confirmVisible.sync="confirmVisible"
                :tableItem="tableItem"
            ></workOrderConfirm>
            <editEstime
                :editEstimeVisible.sync="editEstimeVisible"
                :tableItem="tableItem"
            ></editEstime>
        </div>
        <el-drawer
        :visible.sync="trackVisible"
        direction="rtl"
        :before-close="trackClose"
        :close-on-press-escape="false"
        custom-class="track-list"
        size="35%"
        >
            <template slot="title">
                <div style="display: flex; align-items: center;">
                    <div>BUG - {{ trackType }}</div>
                    <div style="width: 60%;margin-left: auto; margin-right: 10px;">
                        <el-input placeholder="关键词" size="mini" prefix-icon="el-icon-search" v-model="trackKeyword" :disabled="trackList.length < 1" clearable style="display: block"></el-input>
                    </div>
                    <div><el-button v-if="isTester && trackType === '待修复' && !newTrack" :underline="false" @click="showEditor" type="primary" style="padding:5px 8px"><i class="el-icon-plus" /> 添加</el-button></div>
                </div>
            </template>
            <div class="track-title">
                <el-avatar size="small" :src="tableItem.avatar || tableItem.user_name && `https://uc-api.loratech.cn/dingtalk/2/user/${encodeURIComponent(tableItem.user_name)}/avatar/50` || defaultAvatar"></el-avatar>
                {{ tableItem.name }}
            </div>
            <ul class="list"  style="margin-top:50px">
                <li v-for="(item, index) in (trackKeyword.trim() && trackList.filter(t => t.id.toString().includes(trackKeyword.trim()) || t.content.replace(/<[^>]+>/ig, '').includes(trackKeyword.trim())) || trackList)" :key="index">
                    <span class="item-index">{{ item.idx }}</span>
                    <div class="item-content">
                        <div v-html='item.content && item.content.replace(/(<img[^>]+src=")([^"]+)("[^>]*>)/ig, "<a href=\"#\" onclick=\"window.showDocument(event)\">$1$2$3</a>") || ""'></div>
                        <el-alert style="margin-top: 12px; padding: 8px;" v-if="item.status < 3 && item.reject_reason && item.reject_reason.trim()" :title="`驳回原因：${item.reject_reason}`" type="error" :closable="false"></el-alert>
                        <div style="margin-top: 12px; display: flex; align-items: center; font-size: 12px;"><el-avatar size="small" style="width: 16px; height: 16px; opacity: .85;" :src="getInfo(item.creator_id, 'avatar')"></el-avatar><span style="transform: scale(.8); color: #999">{{ getInfo(item.creator_id, 'name') }} {{ item.create_time | timeFormat }}</span></div>
                    </div>
                    <span class="item-actions">
                        <el-link v-if="isDeveloper && [0, 2].includes(item.status)" :underline="false" type="primary" @click="setTrackStatus(item, 1)" style="color: #3a7ffa">已修复</el-link>
                        <template v-else-if="isTester">
                            <template v-if="item.status === 1">
                                <el-link :underline="false" type="success" @click="setTrackStatus(item, 3)" style="color: #3a7ffa">验收</el-link><br>
                                <el-popover
                                    placement="left"
                                    width="300"
                                    v-model="item.reject_visible">
                                    <p>
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            size="mini"
                                            placeholder="请输入驳回原因"
                                            v-model="item.reject_reason_new">
                                        </el-input>
                                    </p>
                                    <div style="text-align: right; margin-top: 10px">
                                        <el-button size="mini" type="text" @click="item.reject_visible = false">取消</el-button>
                                        <el-button type="primary" size="mini" @click="setTrackStatus(item, 2)">确定</el-button>
                                    </div>
                                    <el-link slot="reference" :underline="false" type="primary" @click="item.reject_visible = true">驳回</el-link>
                                </el-popover>
                            </template>
                        </template>
                        <el-link v-if="item.creator_id === user_id" :underline="false" @click="removeTrack(item)" title="移除"><i class="el-icon-close" /></el-link>
                    </span>
                </li>
            </ul>
            <div v-if="isTester && trackType === '待修复'" class="new-track">
                <!-- <el-link v-if="!newTrack" :underline="false" @click="showEditor"><i class="el-icon-plus" /> 添加 BUG</el-link> -->
                <template v-if="newTrack">
                    <vue-editor id="editor1" ref="editor1" v-model="trackItem.content" :editorToolbar="[]" placeholder="Bug描述"></vue-editor>
                    <div style="text-align: center; margin-top: 20px;">
                        <el-button size="mini" type="primary" @click="createTrack()">添加</el-button>
                        <el-button size="mini" @click="newTrack = false">取消</el-button>
                    </div>
                </template>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import { tableMixin } from "@/utils/tableMixins.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import pagination from "@/comon/components/pagination";
import popConfirm from "@/comon/components/popConfirm";
import advancedSearch from "@/comon/components/advancedSearch";
import { mapActions } from "vuex";
import util from "@/utils/util.js";
import ElImageCustom from '../../../comon/components/CustomImgUpload/elImageCustom.vue';
import { VueEditor } from 'vue2-editor';
// import Viewer from 'viewerjs';

export default {
    mixins: [tableMixin, infoTagsMixins],
    data() {
        return {
            // win: window,
            defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            searchForm: {
                order_sn: "",
                name: "",
                create_time: "",
                response_time: "",
                project_id: "",
                keyword: "",
                confirmedList: [],
                confirmed: "",
                type:"",
                typeList:[],
                user_id: "",
                handle_user_id: "",
                demand_user_id: "",
            },
            tableData: [],
            role:"",

            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            multipleSelection: [],
            statusList: [],
            projectList: [],
            tableItem: {},
            drawerVisible: false,
            addVisible: false,
            reportVisible: false,
            editVisible: false,
            detailVisible: false,
            showLogVisible: false,
            estimatetimeVisible: false,
            editEstimeVisible: false,
            confirmVisible: false,
            orderby_response_time: null,
            orderby_estimate_time: null,
            orderby_create_time: null,
            orderby_processed_time: null,
            orderby_check_time: null,
            orderby_sort: null,
            refuseVisible: false,
            jobAddVisible: false,
            jobDetailVisible: false,
            daterange: [
                new Date(new Date().getTime() - 3600 * 1000 * 24 * 7),
                new Date(),
            ],
            week: "",
            completionData: [],
            weeks:[],
            reportConrent:"",
            trackItem: {
                workOrderId: 0,
                creatorId: 0,
                submitterId:0,
                content: '',
                status: 0,
                createTime: ''
            },
            trackKeyword: '',
            trackList: [],
            trackVisible: false,
            newTrack: false,
            trackType: '待修复',
            user_id: parseInt(localStorage.getItem('user_id') || '0'),
            isTester: (() => {
                // return true;
                const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
                return info && info.depart_list && [1, 2, 151].includes(info.depart_list[info.depart_list.length - 1]);
            })(),
            isDeveloper: (() => {
                const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
                // 用户 id 10 为黄庆
                return info && (info.id === 10 || info.depart_list && [150].includes(info.depart_list[info.depart_list.length - 1]));
            })()
        };
    },
    methods: {
        changeSort(id,evt){
            oaApi
                .workOrdersSort(
                    {
                    id: id,
                    sort: evt.target.value
                    },
                    "post"
                )
                .then((res) => {
                    this.workOrdersList();
                });
        },
        confirmChange(val) {
            if (val.length > 1) {
                this.searchForm.confirmedList = val.slice(1, 2);
            } else {
                this.searchForm.confirmedList = val;
            }
            this.workOrdersList();
        },
      typeChange(val) {
        if (val.length > 1) {
          this.searchForm.typeList = val.slice(1, 2);
        } else {
          this.searchForm.typeList = val;
        }
        this.workOrdersList();
      },
        ...mapActions(["getStaffSelect"]),
        add() {
            this.addVisible = true;
        },
        clean() {
            this.searchForm = {
                order_sn: "",
                name: "",
                create_time: "",
                response_time: "",
                project_id: "",
                keyword: "",
                confirmedList: [],
                confirmed: "",
                typeList: [],
                type:'',
                user_id: "",
                handle_user_id: "",
                demand_user_id: "",
            };
            this.workOrdersList();
        },
        closeDrawer() {
            this.drawerVisible = false;
        },
        /**
         * 获取table
         */
        workOrdersList(page) {
            page ? (this.paginationData.page = 1) : "";
            if (this.searchForm.confirmedList.length > 0) {
                this.searchForm.confirmed =
                    this.searchForm.confirmedList[0] == "是" ? 1 : 0;
            } else {
                this.searchForm.confirmed = "";
            }
          if (this.searchForm.typeList.length > 0) {
            this.searchForm.type =
                this.searchForm.typeList[0] == "需求" ? 1 : 2;
          } else {
            this.searchForm.type = "";
          }
            oaApi
                .workOrdersList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                      orderby_response_time: this.orderby_response_time,
                      orderby_estimate_time: this.orderby_estimate_time,
                      orderby_create_time: this.orderby_create_time,
                      orderby_processed_time: this.orderby_processed_time,
                      orderby_check_time: this.orderby_check_time,
                      orderby_sort: this.orderby_sort,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.statusList = res.ext.tabs;
                        this.tableData = res.data;
                        this.role = res.ext.role.id;
                        this.paginationData.total = res.total;
                        this.$nextTick(() => {
                            this.$refs['ordersList'].doLayout();
                        })
                        this.closeDrawer();
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.workOrdersList();
        },
      sortChange(column) {
           this.orderby_response_time =null;
           this.orderby_estimate_time = null;
           this.orderby_create_time = null;
           this.orderby_processed_time = null;
           this.orderby_check_time = null;
           this.orderby_sort = null;
        if (column.prop == "response_time") {
          if (column.order == "descending") {
            this.orderby_response_time = "desc";
          } else if (column.order == "ascending") {
            this.orderby_response_time = "asc";
          } else if (column.order == null) {
            this.orderby_response_time = null;
          }
        }
        if (column.prop == "estimate_time") {
          if (column.order == "descending") {
            this.orderby_estimate_time = "desc";
          } else if (column.order == "ascending") {
            this.orderby_estimate_time = "asc";
          } else if (column.order == null) {
            this.orderby_estimate_time = null;
          }
        }
        if (column.prop == "create_time") {
          if (column.order == "descending") {
            this.orderby_create_time = "desc";
          } else if (column.order == "ascending") {
            this.orderby_create_time = "asc";
          } else if (column.order == null) {
            this.orderby_create_time = null;
          }
        }
        if (column.prop == "sort") {
          if (column.order == "descending") {
            this.orderby_sort = "desc";
          } else if (column.order == "ascending") {
            this.orderby_sort = "asc";
          } else if (column.order == null) {
            this.orderby_sort = null;
          }
        }
        if (column.prop == "processed_time") {
          if (column.order == "descending") {
            this.orderby_processed_time = "desc";
          } else if (column.order == "ascending") {
            this.orderby_processed_time = "asc";
          } else if (column.order == null) {
            this.orderby_processed_time = null;
          }
        }
        if (column.prop == "check_time") {
          if (column.order == "descending") {
            this.orderby_check_time = "desc";
          } else if (column.order == "ascending") {
            this. orderby_check_time = "asc";
          } else if (column.order == null) {
            this. orderby_check_time = null;
          }
        }
        this.workOrdersList();
      },
      modifyEstime(row){
            this.editEstimeVisible = true;
            this.tableItem = row;
      },
        /**
         * 根据table数据循环事件分发
         */
        rowDo(row, item) {
            if (item.name == "编辑") {
                this.editVisible = true;
                this.tableItem = row;
            } else if (item.name == "查看") {
                this.detailVisible = true;
                this.tableItem = row;
            } else if (item.name == "拒绝" && item.status_flag == 2) {
                this.refuseVisible = true;
                this.tableItem = row;
            } else if (item.name == "转任务") {
                this.jobAddVisible = true;
                this.tableItem = row;
            }else if (item.name == "日志") {
              this.showLogVisible = true;
              this.tableItem = row;
            }else if (item.name == "转待响应") {
              this.updateStatus(row, item);
            }
        },
        authFunc(funcName) {
            this[funcName]();
        },
        drawerFormKeydown(e) {
            this.workOrdersList();
            this.$refs.confereesSelect.blur();
        },
        updateStatus(row, item) {
            let status = 2;
            switch (item.name) {
                case "提交":
                    status = 2;
                    break;
                case "转设计":
                    status = 3;
                    break;
                case "转评审":
                    status = 5;
                    break;
                case "转待响应":
                    status = 6;
                    break;
                case "响应":
                case "驳回":
                    status = 10;
                    break;
                case "已处理":
                    status = 20;
                    break;
                case "验收":
                    status = 30;
                    break;
                case "完成":
                    status = 40;
                    break;
                case "取消":
                    status = 99;
                    break;
                case "删除":
                    status = null;
                    oaApi.workOrdersList({}, "delete", row.id).then((res) => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success(`${item.name}成功`);
                                this.workOrdersList();
                            }
                        }
                    });
                    break;
                case "确认":
                    status = null;
                    oaApi
                        .workOrdersConfirm({ id: row.id }, "post")
                        .then((res) => {
                            this.$message.success(`${item.name}成功`);
                            this.workOrdersList();
                        });
                    break;
                default:
                    break;
            }
            if (status) {
                oaApi
                    .workOrdersUpdateStatus(
                        {
                            id: row.id,
                            status,
                        },
                        "post"
                    )
                    .then((res) => {
                        this.$message.success(`${item.name}成功`);
                        this.workOrdersList();
                    });
            }
        },
       //提示确认对应的操作
        confirmUpdateStatus (row, item){
          this.$confirm(`您确定${item.name}吗？`).then(_ => {
            this.updateStatus(row, item)

          }).catch(_ => {
            this.$message.warning(`已取消${item.name}操作`);
          });
        },
      workOrderExport() {
        let ids = [];
        this.multipleSelection.forEach(v => ids.push(v.id));
        oaApi
            .workOrderExport(
                {
                  depart_id: this.menuId,
                  ...this.searchForm,
                  selectList: this.selectionUserIdList,
                  ids : ids
                },
                "get"
            )
            .then((res) => {
              if (res) {
                window.open(res.data.url);
              }
            });
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      /**
       * 响应操作
       * @param row
       * @param item
       */
      confirmResponse(row, item){
          if(row.type == 2){
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
            const day = date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`
            const newDate = `${year}-${month}-${day}`
            //如果是bug直接当前时间加48小时
            oaApi
                .workOrdersUpdateStatus(
                    {
                      id: row.id,
                      status: 10,
                      estimate_time : util.getNewData(newDate, 2),
                      is_response : 1
                    },
                    "post"
                )
                .then((res) => {
                  this.$message.success(`响应成功`);
                  this.workOrdersList();
                });
          }else{
            this.estimatetimeVisible = true;
            this.tableItem = row;
          }
      },
      confirmed(row, item){
            this.confirmVisible = true;
            this.tableItem = row;
      },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            oaApi.projectSelect({}, "get").then((res) => {
                if (res.code == 200) {
                    this.projectList = res.data;
                }
            });
        },
        workOrderClear() {
            this.workOrdersList();
        },
        jump(row) {
            if (row.job_id > 0) {
                /* this.$router.push({
                    path: "/jobManagement",
                    query: {
                        project_id: row.project_id
                    }
                }); */
                this.jobDetailVisible = true;
                this.tableItem.id = row.job_id;
            }
        },
        /**
         * 工单完成率
         */
        getWorkOrdersCompletion() {
            oaApi
                .workOrdersCompletion(
                    {
                        week: this.week,
                    },
                    "get"
                )
                .then((res) => {
                    if (res.code == 200) {
                        this.completionData = res.data.stat;
                        this.weeks = res.data.weeks;
                    }
                });
        },
        //生成工单周统计
        buildStat(id){
            oaApi
                .buildWorkorderStat(
                    {
                        id: id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res.code == 200) {
                        this.getWorkOrdersCompletion()
                    }
                });
        },
        //查看统计报告
        showReport(content){
            this.reportVisible = true;
            this.reportConrent = content;
        },

        showTrack(row, status) {
            this.tableItem = row;
            this.trackItem.workOrderId = row.id;
            this.trackVisible = true;

            const s = status[0]
            this.trackType = s === 1 && '待验收' || s === 3 && '已验收' || '待修复';

            oaApi.workOrdersTrackList({
                workOrderId: row.id,
                status
            }).then(res => {
                this.trackList = res.data.map(it => {
                    it.reject_visible = false;
                    it.reject_reason_new = it.reject_reason;
                    return it;
                });
            });
        },

        trackClose() {
            this.trackItem = {
                workOrderId: 0,
                creatorId: 0,
                submitterId:0,
                content: '',
                status: 0,
                createTime: ''
            };
            this.trackKeyword = '';
            this.trackList = [];
            this.trackVisible = false;
        },

        setTrackStatus(item, status) {
            oaApi.workOrdersSetTrackStatus({id: item.id, status, reject_reason: item.reject_reason_new}, 'put').then(res => {
                if (res.code !== 200) {
                    this.$message.error(res.msg);
                } else {
                    // item.status = status;
                    const index = this.trackList.findIndex(it => it.id === item.id);
                    this.trackList.splice(index, 1);
                    this.workOrdersList();
                }
            });
        },

        removeTrack(item) {
            oaApi.workOrdersRemoveTrack(item.id, 'delete').then(res => {
                if (res.code !== 200) {
                    this.$message.error(res.msg);
                } else {
                    const index = this.trackList.findIndex(it => it.id === item.id);
                    this.trackList.splice(index, 1);
                    this.workOrdersList();
                }
            })
        },

        createTrack() {
            oaApi.workOrdersCreateTrack(this.trackItem, 'post').then(res => {
                if (res.code !== 200) {
                    this.$message.error(res.msg);
                } else {
                    const creator_id = JSON.parse(localStorage.getItem('userInfo') || '{}').id;
                    this.trackList.push({...JSON.parse(JSON.stringify(this.trackItem)), id: res.data.id, idx: res.data.idx, creator_id});

                    this.trackItem.content = '';
                    this.newTrack = false;
                    this.workOrdersList();
                }
            })
        },

        // 获取员工信息
        getInfo(user_id, attr) {
            const info = this.$store.state.index.staffList.find(s => s.id === user_id);
            if (!info) return;

            if (attr === 'avatar') {
                return info.avatar || info.name && `https://uc-api.loratech.cn/dingtalk/2/user/${encodeURIComponent(info.name)}/avatar/40` || this.defaultAvatar;
            }

            return info[attr];
        },

        showEditor() {
            this.newTrack = true;
            this.$nextTick(() => {
                this.$refs['editor1'].$el.querySelector('.ql-editor').focus()
                // $refs['editor1'].querySelector('.ql-editor').focus()
            })
        }
    },
    mounted() {
        this.projectSelect();
        this.getStaffSelect();
        this.workOrdersList();
        // 初始化工单完成率(默认为最近7天)
        this.daterange = [
            this.moment().subtract(1, "weeks").format("YYYY-MM-DD"),
            this.moment().format("YYYY-MM-DD"),
        ];
        this.getWorkOrdersCompletion();

        if (!window.base64ToArrayBuffer) {
            window.base64ToArrayBuffer = (_base64Str) => {
                var binaryString = window.atob(_base64Str);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                        var ascii = binaryString.charCodeAt(i);
                        bytes[i] = ascii;
                }
                return bytes;
            }

            window.showDocument = (e) => {
                e.preventDefault();
                const t = e.currentTarget.querySelector('img');
                let ready = t.getAttribute('viewer-ready');
                if (!ready) {
                    const viewer = new Viewer(t, {
                        title: false,
                        zIndex: 9999
                    });
                    t.setAttribute('viewer-ready', '1');
                    setTimeout(() => viewer.show(), 120);
                }

                // const img = e.currentTarget.querySelector('img').getAttribute('src');
                // if (img.startsWith('data:image/')) {
                //     const _base64Str = img.split(';base64,');
                //     var byte = base64ToArrayBuffer(_base64Str[1]);
                //     var blob = new Blob([byte], { type: _base64Str[0].substring(5)});
                //     window.open(URL.createObjectURL(blob), "_blank");
                // } else {
                //     window.open(img, "_blank");
                // }
            }
        }

    },
    components: {
        pagination: pagination,
        advancedSearch: advancedSearch,
        popConfirm: popConfirm,
        workOrderAdd: () => import("./workOrder/add.vue"),
        workOrderEdit: () => import("./workOrder/edit.vue"),
        workOrderDetail: () => import("./workOrder/detail.vue"),
        showLogDetail: () => import("./workOrder/showLog.vue"),
        workOrderEstimatetime: () => import("./workOrder/estimatetime.vue"),
        workOrderRefuse: () => import("./workOrder/refuse.vue"),
        workOrderReport: () => import("./workOrder/report.vue"),
        workOrderConfirm: () => import("./workOrder/confirm.vue"),
        jobAdd: () => import("./jobManagement/add.vue"),
        jobDetail: () => import("./jobManagement/detail.vue"),
        search_infoTags: () => import("@/comon/components/search/search_infoTags"),
        editEstime: () => import("./workOrder/editEstime.vue"),
    
        ElImageCustom,
        VueEditor,
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        staffList() {
            return this.$store.state.index.staffList;
        },
        menu_id() {
            return this.$store.state.menu.menu_id
                ? this.$store.state.menu.menu_id
                : localStorage.getItem("menu_id");
        },
        height() {
            return `calc(100% - 44px - 40px - 40px - ${this.minusHeight}px)`;
        },
        searchList() {
            return [
                { label: "关键字", key: "keyword", type: "input" },
                {
                    label: "来源",
                    key: "project_id",
                    type: "select",
                    props: {
                        list: this.projectList,
                        nameKey: "name",
                        valueKey: "id",
                    },
                },
            ];
        }
    }
};
</script>
<style lang="scss" scoped>
.workOrder {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;

    .tableCont {
        width: 100%;
        height: 100%;
        border-left: 1px solid #eee;
        padding: 0 20px;
        box-sizing: border-box;
        .table {
            width: 100%;
            .el-scrollbar__wrap {
                overflow-x: hidden;
            }
            .confirmed {
                color: #57a82f;
                margin-left: 5px;
            }
            .noconfirm {
                // color: #000000;
                margin-left: 5px;
            }
            .list-icon {
                width: 12px;
                height: 12px;
                vertical-align:middle;
            }
          .nameCont {
            display: flex;
            align-items: center;
            justify-content: start;
            .headImg {
              height: 28px;
              width: 28px;
              border-radius: 8px;
              overflow: hidden;
              margin-right: 8px;
              justify-items: flex-start;
              img{
                width: 100%;
              }
            }
            .memberName {
              line-height: 24px;
            }
          }

          .sort-input {

            ::v-deep input {
                background-color: transparent;
                border-color: transparent;
                text-align: center;
                line-height: 24px;
                height: 24px;
                padding: 0;

                &:focus {
                    border-color: #eb5202;
                    background-color: #ffffff;
                }
            }
          }
        }

       
    }
    /* .el-table__row {
        .el-button--small.el-popover__reference {
            margin-left: ;
        }
    } */
    .document {
        height: 100%;
        padding: 2px;
        /* width: 30px;
        height: 30px; */
        // padding: 10px 10px;
        /* [class*=el-icon-]+span{
            margin-left: 0;
        } */
    }

     ::v-deep .track-list {
            text-align: left;

            .el-drawer__header {
                border-bottom: 0;
                .el-input--prefix {
                    .el-input__inner {
                        padding-left: 36px;
                    }
                }
            }

            .el-drawer__body {
                overflow-y: auto;
            }

            .track-title {
                position:absolute;
                left:10px;
                top:35px;
                display: flex;
                align-items: center;
                font-size: 14px;
                margin: 12px;
                gap: 12px;
                background-color: #fff;
                width:100%;
                height: 60px;
                z-index: 999;
            }

            .list {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    border-top: 1px solid #ddd;
                    margin: 12px 24px;
                    padding: 20px 0;
                    display: flex;
                    gap: 12px;
                    .item-index {
                        width: 32px;
                        height: 12px;
                        background-color: #f0f4f1;
                        color: #3a7ffa;
                        text-align: center;
                        display: block;
                        padding: 4px;
                        border-radius: 10px;
                    }
                    .item-content {
                        flex: 1;
                        text-align: left;
                        line-height: 20px;
                        img {
                            max-width: 100%!important;
                        }
                    }
                    .item-actions {
                        .el-link--inner {
                            font-size: 12px;
                            line-height: 20px;
                        }

                        .el-link {
                            +.el-link {
                                margin-left: 12px;
                            }
                        }
                    }
                }
            }

            .new-track {
                margin: 24px;
                padding: 20px 0;
                font-size: 12px;
                border-top: 1px solid #ddd;

                #editor1 {
                    height: 350px;
                }
            }
        }
}
.el-checkbox-group {
  text-align: left !important;
}

.report-icon {
    cursor: pointer;
    &+.report-icon {
        margin-left: 5px;
        color: $theme-color;
    }
}

::v-deep .ql-toolbar {
    display: none;
}

::v-deep .ql-container {
    border-top: 1px solid #ccc !important;
    .ql-editor {
        font-size: 12px;
    }
}
</style>
